import type {ReactElement} from 'react';
import React from 'react';
import {BaseGenerateAiSubtitlesOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/generate-ai-subtitles-option/components/base-generate-ai-subtitles-option/base-generate-ai-subtitles-option';
import {getAiTranscriptParamsForVideo, getSelectableItemDataForVideoData} from '@Libraries/ai-transcript.library';
import {getCurrentPageBackground} from '@Components/poster-editor/poster-editor-reducer';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {clearGeneratedResults, setAiSubtitlesPanelItems} from '@Panels/ai-subtitle-panel/ai-subtitle-reducer';
import {GA4EventName, GA4EventParam, GA4EventParamName, trackPosterBuilderGA4Events} from '@Libraries/ga-events';
import {useAiTranscriptGeneration} from '@Hooks/poster-editor/useAiTranscriptGeneration';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.types';

export function VideoBgGenerateAiSubtitlesOption(): ReactElement<any> | null {
  const dispatch = useAppDispatch();
  const currentPageBackground = useAppSelector(getCurrentPageBackground);
  const {getAiSubtitlesActionForItem, addAiTranscripts} = useAiTranscriptGeneration();

  if (!currentPageBackground) {
    return null;
  }

  if (currentPageBackground.details.type !== BackgroundTypeName.VIDEO) {
    return null;
  }

  const videoBackgroundItemObject = currentPageBackground.details;

  const getLoopCycles = (): number => {
    const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
    if (!currentPage) {
      return 1;
    }
    return currentPage.getDuration() / ((videoBackgroundItemObject.endTime - videoBackgroundItemObject.startTime) / (videoBackgroundItemObject.speed ?? 1));
  };

  const onGenerateAiSubtitles = async (): Promise<void> => {
    const loopCycles = getLoopCycles();

    dispatch(setAiSubtitlesPanelItems([{...getSelectableItemDataForVideoData(videoBackgroundItemObject, loopCycles, 1), isSelected: true}]));

    dispatch(clearGeneratedResults());

    trackPosterBuilderGA4Events(GA4EventName.AI_SUBTITLE_CLICK_CONTEXTUAL_MENU, {[GA4EventParamName.TYPE]: GA4EventParam.VIDEO});

    await addAiTranscripts([getAiTranscriptParamsForVideo(videoBackgroundItemObject, loopCycles)]);
  };

  return (
    <BaseGenerateAiSubtitlesOption
      ctaState={getAiSubtitlesActionForItem(getAiTranscriptParamsForVideo(videoBackgroundItemObject, getLoopCycles()))}
      className="spacing-m-t-2"
      onGenerateClicked={onGenerateAiSubtitles}
    />
  );
}
